import { ChangeDetectorRef, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { AlertService } from 'atlas-alert';
import { Actions, ButtonVariants } from 'atlas-cdk';


@Injectable()
export class ToastService {

    public constructor(
        private readonly store: Store<AppState>,
        private readonly alertService: AlertService,
    ) { }

    launchAlertError(title: string, action: any, content?: string): void {
        this.alertService.create({
            actionLabel: '',
            title,
            content,
            autoclose: 5000,
            width: 'min(1000px, 92vw)',
            action: Actions.error,
            variant: ButtonVariants.outlined,
            horizontalPosition: 'center',
            verticalPosition: 'top',
        });
    }

    launchAlertSuccess(title: string, action: any, content?: string): void {
        this.alertService.create({
            actionLabel: '',
            title,
            content,
            autoclose: 5000,
            width: 'min(1000px, 92vw)',
            action: Actions.success,
            variant: ButtonVariants.outlined,
            horizontalPosition: 'center',
            verticalPosition: 'top',
        });
    }


    launchAlertWarning(title: string, action: any, content?: string): void {
        this.alertService.create({
            actionLabel: '',
            title,
            content,
            autoclose: 5000,
            width: 'min(1000px, 92vw)',
            action: Actions.warning,
            variant: ButtonVariants.outlined,
            horizontalPosition: 'center',
            verticalPosition: 'top',
        });
    }
    public testFunc(): string {
        return 'helloooooooo';
    }
}
